import { Component, Input } from '@angular/core'
import { Transaction } from '../../../types/mpup-types'

@Component({
  selector: 'mb-mpup-transaction-list-item',
  templateUrl: './mpup-transaction-list-item.component.html',
  styleUrls: ['./mpup-transaction-list-item.component.scss']
})
export class MpupTransactionListItemComponent {

  @Input()
  item!: Transaction

  getImagePath () {
    return `assets/images/Icon_${this.item.type}.svg`
  }
}
